import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { getStoredConsent, setConsent } from '../lib/analytics.js';
import styles from './CookieConsent.module.css';

/**
 * The one-time banner that gates PostHog (PLAN.md Phase 8). Rendered at the
 * app root, above routing, so it shows on every screen — including
 * pre-sign-in — until a choice is made, then never again.
 *
 * Cloudflare Web Analytics is deliberately not covered by this: it sets no
 * cookies, so there is nothing here to consent to (see web-analytics.ts).
 */
export default function CookieConsent() {
  const { t } = useTranslation();
  const [choiceMade, setChoiceMade] = useState(() => getStoredConsent() !== null);

  if (choiceMade) return null;

  const choose = (choice: 'accepted' | 'rejected') => {
    setConsent(choice);
    setChoiceMade(true);
  };

  return (
    <div className={styles.banner} role="dialog" aria-label={t('cookieConsent.title')}>
      <p className={styles.text}>
        {t('cookieConsent.body')} <Link to="/privacy">{t('cookieConsent.learnMore')}</Link>
      </p>
      <div className={styles.actions}>
        <button
          type="button"
          className="button button-secondary"
          onClick={() => choose('rejected')}
        >
          {t('cookieConsent.reject')}
        </button>
        <button type="button" className="button button-primary" onClick={() => choose('accepted')}>
          {t('cookieConsent.accept')}
        </button>
      </div>
    </div>
  );
}
